import { useI18n, useMoneyFormatter } from "@expertloop/i18n/react";
import type { MediationDossierView } from "@expertloop/shared";

interface MediationSnapshotProps {
	dossier: MediationDossierView;
	/** Pièces jointes de la conversation (fichiers, vocaux, vidéos) ; à défaut, celles que compte le dossier. */
	attachments?: number;
}

/** Situation d'un coup d'œil : prix de départ, prix net, nombre d'échanges et de pièces jointes. */
export function MediationSnapshot({ dossier, attachments }: MediationSnapshotProps) {
	const { t } = useI18n();
	const { formatCents } = useMoneyFormatter();
	const { price, counts } = dossier;
	const attachmentCount = attachments ?? counts.files;

	return (
		<section className="card mediation-snapshot" aria-label={t("adminChatDetail.dossier.summaryTitle")}>
			<div className="card-body mediation-snapshot-grid">
				<div>
					<span className="mediation-snapshot-label">{t("adminChatDetail.dossier.initialPrice")}</span>
					<strong>{formatCents(price.initialAmount, price.currency)}</strong>
				</div>
				<div>
					<span className="mediation-snapshot-label">{t("adminChatDetail.dossier.agreedPrice")}</span>
					<strong>{formatCents(price.netAmount, price.currency)}</strong>
				</div>
				<div>
					<span className="mediation-snapshot-label">{t("adminChatDetail.dossier.exchanges")}</span>
					<strong>{t("adminChatDetail.dossier.exchangesValue", { count: counts.messages, plural: counts.messages !== 1 ? "s" : "" })}</strong>
				</div>
				<div>
					<span className="mediation-snapshot-label">{t("adminChatDetail.dossier.attachments")}</span>
					<strong>{attachmentCount}</strong>
				</div>
			</div>
		</section>
	);
}
